import React, { useEffect, useState } from 'react'
import _ from 'lodash'
import { useIntl } from 'react-intl'
import CompaniesService from '../../../../services/companies/companies.service'
import UsersService from '../../../../services/users/users.service'
import { ACTIVITY_TYPES } from '../../../../utils/constants/activityTypes'
import { ZONES } from '../../../../utils/constants/zones'
import LabeledDropdown from '../../../../components/common/form-components/labeled-dropdown/LabeledDropdown'
import LabeledCheckbox from '../../../../components/common/form-components/labeled-checkbox/LabeledCheckbox'
import LabeledText from '../../../../components/common/form-components/labeled-inputs/LabeledText'
import useInputs from '../../../../utils/hooks/useInputs'
import CenterService from '../../../../services/centers/center.service'
import CenterSettingsService from '../../../../services/settings/centers/centerSettings.service'

import './centerForm.scss'
import DeleteButton from '../../../../components/common/buttons/DeleteButton'
import SaveButton from '../../../../components/common/buttons/SaveButton'
import swalAlert from '../../../../utils/helpers/swalAlert'
import { AppModalContent } from '../../../../component/layout/AppModal'
import { Group, Stack } from '@mantine/core'
import AppButton from '../../../../component/common/AppButton'
import EntityDropdown from '../../../../component/form/EntityDropdown'
import AppInput from '../../../../component/form/AppInput'

const CenterTechnicsOtherForm = ({
  centerId,
  selectedItem,
  hide,
  updateInputs: updateTechnicsInputs,
}) => {
  const { formatMessage: msg } = useIntl()

  const [otherTypes, setOtherTypes] = useState()

  const { inputs, onChangeInputs, updateInputs } = useInputs()

  useEffect(() => {
    getOtherTypes()
  }, [])

  useEffect(() => {
    updateInputs(selectedItem)
    // if(selectedItem)
  }, [selectedItem])

  const getOtherTypes = async () => {
    const response = await CenterSettingsService.otherTecnicsTypes.getAll({})
    if (response) {
      setOtherTypes(response.resp)
    }
  }

  const handleSave = async () => {
    // console.log('handleSave')
    if (centerId && centerId !== 'undefined' && !selectedItem) {
      const data = {
        ...inputs,
      }
      const response = await CenterService?.technics?.others?.create({
        id: centerId,
        body: data,
      })
      // console.log('response', response)
      if (response) {
        updateTechnicsInputs(response?.resp)
        hide()
      }
    }
  }

  const handleRemove = async () => {
    if (selectedItem?._id) {
      const response = await CenterService?.technics?.others?.remove({
        id: centerId,
        rowId: selectedItem?._id,
      })
      if (response) {
        updateTechnicsInputs(response?.resp)
        hide()
        swalAlert('success', msg({ id: 'center.technics.track.removed' }))
      } else {
        swalAlert('error', msg({ id: 'center.technics.track.error' }))
      }
    }
  }

  return (
    <AppModalContent
      buttons={[
        selectedItem && <AppButton preset="remove" onClick={handleRemove} />,
        <AppButton preset="save" onClick={handleSave} />,
      ]}
      content={
        <Stack w="100%">
          <Group>
            <EntityDropdown
              icon="technics"
              label="otherTechnicType"
              withAsterisk
              name="otherTypesId"
              value={inputs?.otherTypesId}
              options={otherTypes}
              onChange={onChangeInputs}
            />
            <AppInput
              entity="technics"
              label="model"
              withAsterisk
              name="model"
              value={inputs?.model}
              onChange={onChangeInputs}
            />
          </Group>
          <Group>
            <AppInput
              entity="technics"
              label="brand"
              name="brand"
              value={inputs?.brand}
              onChange={onChangeInputs}
            />
            <AppInput
              entity="technics"
              label="capacity"
              name="capacity"
              value={inputs?.capacity}
              onChange={onChangeInputs}
            />
          </Group>
          <Group>
            <AppInput
              label="observations"
              name="observations"
              value={inputs?.observations}
              onChange={onChangeInputs}
            />
          </Group>
        </Stack>
      }
    />
  )
}

export default CenterTechnicsOtherForm
